import React from 'react';
import { 
  FormControl, 
  FormLabel, 
  FormGroup, 
  FormControlLabel, 
  Checkbox,
  FormHelperText 
} from '@mui/material';
import { Controller, Control, FieldError } from 'react-hook-form';

interface FormCheckboxGroupProps {
  name: string;
  control: Control<any>;
  label?: string;
  options: Array<{ value: string; label: string }>;
  required?: boolean;
}

const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({ 
  name, 
  control, 
  label, 
  options,
  required 
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }: { field: any; fieldState: { error?: FieldError } }) => (
        <FormControl error={!!error} component="fieldset">
          {label && <FormLabel component="legend">{label}{required && ' *'}</FormLabel>}
          <FormGroup row>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={field.value?.includes(option.value) || false}
                    onChange={(e) => {
                      const newValue = [...(field.value || [])];
                      if (e.target.checked) {
                        newValue.push(option.value);
                      } else {
                        const index = newValue.indexOf(option.value);
                        if (index > -1) {
                          newValue.splice(index, 1);
                        }
                      }
                      field.onChange(newValue);
                    }}
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default FormCheckboxGroup; 